import { useEffect, useState } from 'react'
import Link from '@/components/Common/Link'
import {
  getLocalStorage,
  setLocalStorage,
} from '@/root/utils/cookie-localStorage-utils'
import Modal from '@/stories/components/Common/Modal'
import { useQuery } from 'react-query'
import { fetchRequest } from '@/root/utils/network-adapter/fetch-request'
import { vyaparBOApiBaseUrl } from '@/root/api/apiConstants'
import { TUserDetailsDemat } from '@/stencil/investments/futures-and-options/orders'
import useGetAuthToken from '@/hooks/use-get-auth-token'
import Cookies from 'js-cookie'

export default function RiskDisclosureModal() {
  const [showModal, setShowModal] = useState(false)

  const token = useGetAuthToken()

  const member_id = Cookies.get('memberId')

  const { data } = useQuery<TUserDetailsDemat>(
    'fno-onboarding-status',
    () =>
      fetchRequest({
        config: {
          headers: {
            Authorization: `Bearer ${token}`,
            Platform: 'web',
          },
        },
        timeout: 0,
        url: `${vyaparBOApiBaseUrl}/onboard/status?segment=equity_derivative${
          member_id ? `&member_id=${member_id}` : ''
        }`,
      }),
    {
      enabled: !!token,
    },
  )

  useEffect(() => {
    const showModalLS = getLocalStorage('risk-disclosure-show')
    if (showModalLS === 'y' && data?.is_onboarded) {
      setShowModal(true)
    }
  }, [data?.is_onboarded])

  return (
    <Modal
      contentClassName="rounded-xl bg-brand-tertiary-grey shadow-four"
      bodyClassName="max-w-2xl h-3/4 overflow-scroll md:h-4/5 lg:h-3/4"
      showModal={showModal}
    >
      <div className="flex flex-col items-center justify-start p-5 ">
        <p className="self-start text-xl font-semibold">
          Risk Disclosure on Derivatives
        </p>
        <ul className="list-disc p-4">
          <li className="px-1">
            9 out of 10 individual traders in equity Futures and Options
            Segment, incurred net losses.
          </li>
          <li className="mt-4 px-1">
            On an average, loss makers registered net trading loss close to
            ₹50,000.
          </li>
          <li className="mt-4 px-1">
            Over and above the net trading losses incurred, loss makers expended
            an additional 28% of net trading losses as transaction costs.
          </li>
          <li className="mt-4 px-1">
            Those making net trading profits, incurred between 15% to 50% of
            such profits as transaction cost.
          </li>
        </ul>
        <p className="text-brand-grey-base text-left text-sm">
          Source:{' '}
          <Link
            href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html"
            className="text-brand-blue-azureRadiance"
            openInNewTab
          >
            SEBI study
          </Link>{' '}
          dated January 25, 2023 on “Analysis of Profit and Loss of Individual
          Traders dealing in equity Futures and Options (F&O) Segment”, wherein
          Aggregate Level findings are based on annual Profit/Loss incurred by
          individual traders in equity F&O during FY 2021-22.
        </p>
        <button
          className="bg-brand-green-dark hover:bg-brand-grey-background border-brand-green-dark border-1 hover:text-brand-green-dark sticky bottom-5 my-6 w-1/2 rounded-full px-6 py-4 text-white transition-all hover:scale-[97%]"
          onClick={() => {
            setShowModal(false)
            setLocalStorage('risk-disclosure-show', 'n')
          }}
        >
          I Understand
        </button>
      </div>
    </Modal>
  )
}
